import React, {useState} from 'react';
import moment from 'moment';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import ButtonAction from '../../../../_common/components/ButtonAction';
import FieldInput from '../../../../_common/components/FieldInput';
import FieldSelect from '../../../../_common/components/FieldSelect';
import {DatePicker} from '../../../../_common/components/FieldDatepicker';
import {floatValue, formatStringToNumber} from '../../../../../../utils/format';
import {optionsSubType} from '../../../constants/options';
import {
  createDocumentGridReceiptOtherSelectStyles,
  createDocumentGridSelectStyles
} from '../../../../_common/selectStyles/customSelectStyles';
import styles from '../styles.module.scss';

const RowOther = ({
                    setFieldValue,
                    fieldsSet,
                    values,
                    removeRow,
                  }) => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className={styles.otherRowContainer}>
      <DatePicker
        value={startDate}
        onChange={(date) => {
          setStartDate(date);
          setFieldValue(fieldsSet.date, date);
        }}
        minDate={moment().subtract(1, 'months').format('YYYY-MM-DD')}
        maxDate={moment().add(1, 'years').format('YYYY-MM-DD')}
      />
      <FieldSelect
        fieldId={fieldsSet.subType}
        customStyles={{...createDocumentGridSelectStyles, ...createDocumentGridReceiptOtherSelectStyles}}
        options={optionsSubType}
        value={values[fieldsSet.subType]}
      />
      <FieldInput fieldId={fieldsSet.transactionId} onChange={formatStringToNumber}/>
      <FieldInput fieldId={fieldsSet.price} onChange={floatValue}/>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'error'}
        onClick={removeRow}
        label={<img src={toAbsoluteUrl('/media/common/Delete_red.svg')} alt="delete"/>}
        customClassnames={'mr-4 ml-auto'}
        avoidDoubleClick={false}
      />
    </div>
  );
};

export default RowOther;